import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MappingComponent } from "./components/mapping/mapping.component";
import { DataViewComponent } from "./components/data-view/data-view.component";
import { QualityGateComponent } from "./components/quality-gate/quality-gate.component";
import { InboxComponent } from "./components/inbox/inbox.component";
import { LoginComponent } from "./components/login/login.component";
import { ExceptionHandlingComponent } from "./components/exception-handling/exception-handling.component";
import { InsiderTradingPlansComponent } from "./components/insider-trading-plans/insider-trading-plans.component";
import { IssuerDetailsComponent } from "./components/issuer-details/issuer-details.component";
import { InsiderDetailsComponent } from "./components/insider-details/insider-details.component";

const routes: Routes = [
  { path: "", redirectTo: "inbox", pathMatch: "full" },
  { path: "mapping", component: MappingComponent },
  { path: "data-view", component: DataViewComponent },
  { path: "quality-gate", component: QualityGateComponent },
  { path: "inbox", component: InboxComponent },
  { path: "login", component: LoginComponent },
  { path: "exception-handling", component: ExceptionHandlingComponent },
  {path:"insider-trading-plans", component: InsiderTradingPlansComponent},
  {path:"issuer-details", component: IssuerDetailsComponent},
  {path:"insider-details", component: InsiderDetailsComponent},

  { path: "**", redirectTo: "inbox" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
